export default [{
    text: 'Косметический',
    value: 'cosmetic',
}, {
    text: 'Евро',
    value: 'euro',
}, {
    text: 'Дизайнерский',
    value: 'design',
}, {
    text: 'Без ремонта',
    value: 'no',
}];
